module.exports = __webpack_public_path__ + "img/offline-big.e45aa603.svg";